export default __webpack_public_path__ + "static/media/granville10.be996a57.jpg";